import { Alert, Grid } from '@arco-design/web-react';
import 'codemirror/addon/fold/xml-fold'; // Required for folding in XML/HTML mode
import 'codemirror/lib/codemirror.css';
import 'codemirror/mode/htmlmixed/htmlmixed';
import React from 'react';
import { Controlled as CodeMirror } from 'react-codemirror2';

const { Row, Col } = Grid;

// MUI -> Arco. Only the layout wrappers (Grid -> Arco Grid, /12 -> /24; Alert ->
// Arco Alert with type/content) are converted; the CodeMirror logic is untouched.
const TextEmailEditor = (props) => {
    const { textContent, setTextContent } = props;

    const handleChange = (editor, data, value) => {
        setTextContent(value);
    };

    const lines = textContent && textContent.split("\n") || [];
    const theContent = lines.length > 10 ? textContent : textContent + "\n".repeat(10 - lines.length)



    return (
        <Row>
            <Col span={24}>
                <Alert type="info" content="Some recipients use email clients that only support TEXT, this is what they'll see." />
            </Col>
            <Col span={24}>
                <CodeMirror
                    value={theContent}
                    options={{
                        mode: 'text',
                        theme: 'base16-light',
                        lineNumbers: true,
                        // viewportMargin: Infinity,
                        // minHeight: 300,
                        // height: Math.min(700, textContent.split('\n').length * 20 + 50),
                        // viewportMargin: Infinity,
                        // minHeight: 300,
                        // maxHeight: 700,
                    }}
                    onBeforeChange={handleChange}
                />
            </Col>
        </Row>
    );
};

export default TextEmailEditor;
